import React from 'react';
import { SubNav } from './primitives';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import { formatDtmObj } from './utils';

import styles from './__styles__/index.scss?modules';

const { AqxIcon, Modal, Header, Menu, SubnavLink, CallbackCta } = SubNav;

const USCommercialSubNav = ({
  header,
  phoneNumber,
  createLinkNav,
  showCta,
  open,
  toggleOpen,
  variantOpen,
  toggleVariantOpen
}) => {
  const headerClick = () => {
    if (variantOpen) {
      toggleVariantOpen(false);
    }
    toggleOpen(prev => !prev);
    sendDTMClickEvent(formatDtmObj(open ? 'gcs-subnav-close' : 'gcs-subnav-open'));
  };

  return (
    <nav className={styles.subNavBox} aria-label="Navigation Menu">
      <Header
        open={open}
        onClick={headerClick}
        ariaLabel="Open Business Navigation Menu"
      >
        {header}
      </Header>
      <Modal open={open} className={styles.subNavModal}>
        <ul className={styles.modalUl}>
          <SubnavLink
            icon={<AqxIcon imageName="dls-icon-bank-subnav" />}
            href={
              createLinkNav
                ? createLinkNav('/us/credit-cards/business/', {
                    type: 'linkNav',
                    tag: 'SubNav-BusinessesCards-ViewAllBusinessCards'
                  })
                : '/us/credit-cards/business/'
            }
          >
            Business Services Home
          </SubnavLink>
          <Menu
            content="Business Cards"
            icon={open => (
              <AqxIcon
                imageName={`dls-icon-card-subnav${open ? '-filled' : ''}`}
                open={open}
              />
            )}
            dtmExpand="gcs-subnav-businesscard-expand"
            dtmCollapse="gcs-subnav-businesscard-collapse"
          >
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav(
                      '/us/credit-cards/business/business-credit-cards/',
                      {
                        type: 'linkNav',
                        tag: 'SubNav-BusinessesCards-ViewAllBusinessCards'
                      }
                    )
                  : '/us/credit-cards/business/business-credit-cards/'
              }
            >
              View All Business Cards
            </SubnavLink>
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav(
                      '/us/credit-cards/business/business-credit-cards/compare-credit-cards/',
                      {
                        type: 'linkNav',
                        tag: 'SubNav-BusinessesCards-CompareCards'
                      }
                    )
                  : '/us/credit-cards/business/business-credit-cards/compare-credit-cards/'
              }
            >
              Compare Cards
            </SubnavLink>
            <li>
              <hr className={styles.modalHr} />
            </li>
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav(
                      '/us/credit-cards/business/corporate-credit-cards/',
                      {
                        type: 'linkNav',
                        tag: 'SubNav-ForLargeCorporations'
                      }
                    )
                  : '/us/credit-cards/business/corporate-credit-cards/'
              }
            >
              Corporate Card Programs
            </SubnavLink>
          </Menu>
          <Menu
            content="Financing Solutions"
            icon={open => (
              <AqxIcon
                imageName={`dls-icon-statement-ready-subnav${open ? '-filled' : ''}`}
                open={open}
              />
            )}
            dtmExpand="gcs-subnav-financingsolutions-expand"
            dtmCollapse="gcs-subnav-financingsolutions-collapse"
          >
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav(
                      '/en-us/business/blueprint/business-line-of-credit/',
                      {
                        type: 'linkNav',
                        tag: 'SubNav-FinancingSolutions-BusinessLoans'
                      }
                    )
                  : '/en-us/business/blueprint/business-line-of-credit/'
              }
            >
              Business Line of Credit
            </SubnavLink>
          </Menu>
          <Menu
            content="Checking & Payment Solutions"
            icon={open => (
              <AqxIcon
                imageName={`dls-icon-check-banking-subnav${open ? '-filled' : ''}`}
                open={open}
              />
            )}
            dtmExpand="gcs-subnav-checkingpaymentproducts-expand"
            dtmCollapse="gcs-subnav-checkingpaymentproducts-collapse"
          >
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav('/en-us/business/checking/', {
                      type: 'linkNav',
                      tag: 'SubNav-PaymentSolutions-BusinessChecking'
                    })
                  : '/en-us/business/checking/'
              }
            >
              Business Checking
            </SubnavLink>
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav('/en-us/business/global-pay/', {
                      type: 'intlink',
                      tag: 'SubNav-PaymentSolutions-GlobalPay'
                    })
                  : '/en-us/business/global-pay/'
              }
            >
              American Express Global Pay<sup>TM</sup>
            </SubnavLink>
            <li>
              <hr className={styles.modalHr} />
            </li>
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav(
                      '/en-us/business/payment-solutions/employee-spending/',
                      {
                        type: 'linkNav',
                        tag: 'SubNav-PaymentSolutions-EmployeeSpending'
                      }
                    )
                  : '/en-us/business/payment-solutions/employee-spending/'
              }
            >
              Employee Spending
            </SubnavLink>
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav(
                      '/en-us/business/payment-solutions/vendor-payments/',
                      {
                        type: 'linkNav',
                        tag: 'SubNav-PaymentSolutions-VendorPayments'
                      }
                    )
                  : '/en-us/business/payment-solutions/vendor-payments/'
              }
            >
              Vendor Payments
            </SubnavLink>
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav(
                      '/en-us/business/payment-solutions/accounts-payable-automation/',
                      {
                        type: 'linkNav',
                        tag: 'SubNav-PaymentSolutions-AutomatedPayments'
                      }
                    )
                  : '/en-us/business/payment-solutions/accounts-payable-automation/'
              }
            >
              Automated Payments
            </SubnavLink>
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav('/en-us/business/payment-solutions/', {
                      type: 'linkNav',
                      tag: 'SubNav-PaymentSolutions-ViewAllPaymentSolutions'
                    })
                  : '/en-us/business/payment-solutions/'
              }
            >
              View All Payment Solutions
            </SubnavLink>
          </Menu>
          <Menu
            content="Resources"
            icon={open => (
              <AqxIcon
                imageName={`dls-icon-info-subnav${open ? '-filled' : ''}`}
                open={open}
              />
            )}
            dtmExpand="gcs-subnav-resources-expand"
            dtmCollapse="gcs-subnav-resources-collapse"
          >
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav('/en-us/business/trends-and-insights/', {
                      type: 'intlink',
                      tag: 'SubNav-Resources-TrendsAndInsights'
                    })
                  : '/en-us/business/trends-and-insights/'
              }
            >
              Business Class
            </SubnavLink>
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav('/us/merchant/accept-the-card.html', {
                      type: 'intlink',
                      tag: 'SubNav-Resources-MerchantAcceptance'
                    })
                  : '/us/merchant/accept-the-card.html'
              }
            >
              Merchant Acceptance
            </SubnavLink>
            <SubnavLink
              href={
                createLinkNav
                  ? createLinkNav('/en-us/business/travel/', {
                      type: 'intlink',
                      tag: 'SubNav-Resources-GlobalBusinessTravel'
                    })
                  : '/en-us/business/travel/'
              }
            >
              Global Business Travel
            </SubnavLink>
          </Menu>
        </ul>
        {showCta && (
          <footer className={styles.subNavFooter}>
            <CallbackCta
              content="Call to apply"
              phoneNumber={phoneNumber}
              ctaDtm="SubNav-CallToApply"
            />
          </footer>
        )}
      </Modal>
    </nav>
  );
};

export default USCommercialSubNav;
